
import { checkboxTermTemplate } from "../templates";
var FilterCheckboxTerm = Backbone.View.extend({
    tagName: 'div',
    className: 'filter-check',
    events: {
        'click input' : 'selectTerm'
    },
    initialize: function(){
        _.bindAll( this, 'render', 'selectTerm' );
        this.render();
    },
    /*
    Render the view markup
    */
    render: function(){
        var details = this.model.toJSON();
        window.debugLogger( details );
        var itemHtml = checkboxTermTemplate( details );
        this.el.innerHTML = itemHtml;
    },
    /*
    Update this views model based on the checkbox selection
    */
    selectTerm : function( e ){
        e.preventDefault();
        // maybe link this with the "checked" property of e instead of just reversing?
        var selected = this.model.get( 'selected' );
        window.debugLogger( e.currentTarget.checked, selected );
        this.model.set({'selected': e.currentTarget.checked });
    }
});



export {FilterCheckboxTerm};